import { InputTime } from './InputTime';

export { TIME_FORMAT } from './constants';
export default InputTime;
